import { useFindAllRmasQuery } from '../api/api-hooks';
import { getMMDDYYForDate, getMMDDYYForToday } from '../utils/dateTime';
import { Form } from '../utils/sharedTypes';

const useRMAMiddleware = () => {
  const { data: rmas } = useFindAllRmasQuery({});
  if (rmas === undefined)
    return (
      name: string,
      value: string,
      state: Form,
      autoboxValue?: object,
      autoboxLabel?: string
    ): object => {
      let dateString: string;
      if (!state.creationDate) dateString = getMMDDYYForToday();
      else dateString = getMMDDYYForDate(new Date(state.creationDate));
      if (autoboxValue) {
        if (autoboxLabel === 'hardware') {
          return { nameId: `99${value}-${dateString}` };
        }
      }
      if (name === 'isRepaired') {
        return { isRepaired: !state.isRepaired };
      } else {
        return {};
      }
    };
  return (
    name: string,
    value: string,
    state: Form,
    autoboxValue?: any,
    autoboxLabel?: string
  ) => {
    let dateString: string;
    if (!state.creationDate) dateString = getMMDDYYForToday();
    else dateString = getMMDDYYForDate(new Date(state.creationDate));
    if (autoboxLabel) {
      if (autoboxValue === null) return { [autoboxLabel]: null };
      if (autoboxLabel === 'hardware') {
        const selectedRmas = rmas.filter(
          (rma) => rma.hardware.serial === autoboxValue.serial
        );
        return {
          nameId: `99${autoboxValue.serial}-${dateString}-${
            selectedRmas.length + 1
          }`,
          hardware: autoboxValue,
        };
      }
      if (autoboxLabel === 'company') {
        return { company: autoboxValue };
      }
      if (autoboxLabel === 'order') {
        return { order: autoboxValue };
      }
    }
    if (name === 'isRepaired') {
      return { isRepaired: !state.isRepaired };
    } else {
      return {};
    }
  };
};

export default useRMAMiddleware;
